module.exports = __webpack_public_path__ + "static/media/Subaru_logo.ca038311.svg";